import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CinemaFrame } from "@/components/CinemaChrome";
import CinematicLanding from "@/pages/CinematicLanding";
import { lazy, Suspense } from "react";
const DemoFriseur = lazy(() => import("@/pages/DemoFriseur"));
import ServicePage from "@/pages/ServicePage";
import ContactPage from "@/pages/ContactPage";
import NotFoundPage from "@/pages/NotFoundPage";
import PrivacyPage from "@/pages/PrivacyPage";

const MarketingPage = ({ children }) => (
  <CinemaFrame>{children}</CinemaFrame>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CinematicLanding />} />
          <Route path="/webdesign-fuer-unternehmen" element={<MarketingPage><ServicePage pageKey="unternehmen" /></MarketingPage>} />
          <Route path="/landingpage-erstellen-lassen" element={<MarketingPage><ServicePage pageKey="landingpage" /></MarketingPage>} />
          <Route path="/website-relaunch" element={<MarketingPage><ServicePage pageKey="relaunch" /></MarketingPage>} />
          <Route path="/webdesign-berlin" element={<MarketingPage><ServicePage pageKey="berlin" /></MarketingPage>} />
          <Route path="/kontakt" element={<MarketingPage><ContactPage /></MarketingPage>} />
          <Route path="/datenschutz" element={<MarketingPage><PrivacyPage /></MarketingPage>} />
          <Route path="/demo/friseur" element={<Suspense fallback={<main aria-busy="true" style={{padding:40}}>Salon-Konzept wird geladen …</main>}><DemoFriseur /></Suspense>} />
          <Route path="*" element={<MarketingPage><NotFoundPage /></MarketingPage>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
